// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/stall-recovery-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/stall-recovery-technique/stall-recovery-technique.js';

mount([g0]);
